import { render, staticRenderFns } from "./CalendarEventEditorEmployee.vue?vue&type=template&id=4dff5500&scoped=true&lang=pug&"
import script from "./CalendarEventEditorEmployee.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventEditorEmployee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dff5500",
  null
  
)

export default component.exports